import Alert from './Alert'

export default class ErrorAlert extends Alert{
    show() {
        return swal({
            title: this.key('title', uLang('app.error')),
            text: this.key('text'),
            icon: "error",
            button: this.key('button', uLang('app.close')),
            closeOnClickOutside: false,
            closeOnEsc: false,
        })
    }
}
